// extracted by mini-css-extract-plugin
export default {"root":"contactSelectionChips_root__Tp7qo","chip":"contactSelectionChips_chip__fKNNL"};